module.exports = __webpack_public_path__ + "assets/img/plus.fd955a26.png";